import { ActionCreator } from "../types/store-types";
import {
    AddFieldToPageActionType,
    ChangeCurrentPageActionType,
    ChangePageOrderFailureActionType,
    ChangePageOrderRequestActionType,
    ChangePageOrderSuccessActionType,
    CreatePageByTempIdActionType,
    CreatePageFailureActionType,
    CreatePageRequestActionType,
    CreatePageSuccessActionType,
    DeleteFieldActionType,
    DeletePageFailureActionType,
    DeletePageRequestActionType,
    DeletePageSuccessActionType,
    DuplicateFieldActionType,
    InitPagesActionType,
    PagesActionTypes,
    ReplaceFieldIdActionType,
    UpdatePageDataRequestActionType,
    UpdatePageDataFailureActionType,
    UpdatePageDataSuccessActionType,
    UpdatePageFailureActionType,
    UpdatePageRequestActionType,
    UpdatePageSuccessActionType,
} from "./types";

export const InitPages: ActionCreator<InitPagesActionType> = payload => ({
    type: PagesActionTypes.INIT_PAGES,
    payload,
});

export const changeCurrentPage: ActionCreator<ChangeCurrentPageActionType> = payload => ({
    type: PagesActionTypes.CHANGE_CURRENT_PAGE,
    payload,
});

/* Field Stuff */

export const addFieldToPage: ActionCreator<AddFieldToPageActionType> = payload => ({
    type: PagesActionTypes.ADD_FIELD_TO_PAGE,
    payload,
});

export const replaceFieldId: ActionCreator<ReplaceFieldIdActionType> = payload => ({
    type: PagesActionTypes.REPLACE_FIELD_ID,
    payload,
});

export const deleteField: ActionCreator<DeleteFieldActionType> = payload => ({
    type: PagesActionTypes.DELETE_FIELD,
    payload,
});

export const duplicateField: ActionCreator<DuplicateFieldActionType> = payload => ({
    type: PagesActionTypes.DUPLICATE_FIELD,
    payload,
});

/* -- Create Page Actions -- */

export const createPageByTempId: ActionCreator<CreatePageByTempIdActionType> = payload => ({
    type: PagesActionTypes.CREATE_PAGE_BY_TEMP_ID,
    payload,
});

export const createPageRequest: ActionCreator<CreatePageRequestActionType> = payload => ({
    type: PagesActionTypes.CREATE_PAGE_REQUEST,
    payload,
});

export const createPageSuccess: ActionCreator<CreatePageSuccessActionType> = payload => ({
    type: PagesActionTypes.CREATE_PAGE_SUCCESS,
    payload,
});

export const createPageFailure: ActionCreator<CreatePageFailureActionType> = payload => ({
    type: PagesActionTypes.CREATE_PAGE_FAILURE,
    payload,
});

/* -- Delete Page Actions -- */

export const deletePageRequest: ActionCreator<DeletePageRequestActionType> = payload => ({
    type: PagesActionTypes.DELETE_PAGE_REQUEST,
    payload,
});

export const deletePageSuccess: ActionCreator<DeletePageSuccessActionType> = payload => ({
    type: PagesActionTypes.DELETE_PAGE_SUCCESS,
    payload,
});

export const deletePageFailure: ActionCreator<DeletePageFailureActionType> = payload => ({
    type: PagesActionTypes.DELETE_PAGE_FAILURE,
    payload,
});

/* -- Page Sorting Actions */

export const changePageOrderRequest: ActionCreator<ChangePageOrderRequestActionType> = payload => ({
    type: PagesActionTypes.CHANGE_PAGE_ORDER_REQUEST,
    payload,
});

export const changePageOrderSuccess: ActionCreator<ChangePageOrderSuccessActionType> = payload => ({
    type: PagesActionTypes.CHANGE_PAGE_ORDER_SUCCESS,
    payload,
});

export const changePageOrderFailure: ActionCreator<ChangePageOrderFailureActionType> = payload => ({
    type: PagesActionTypes.CHANGE_PAGE_ORDER_FAILURE,
    payload,
});

/* -- Update Page Data Actions -- */

export const updatePageDataRequest: ActionCreator<UpdatePageDataRequestActionType> = payload => ({
    type: PagesActionTypes.UPDATE_PAGE_DATA_REQUEST,
    payload,
});

export const updatePageDataFailure: ActionCreator<UpdatePageDataFailureActionType> = payload => ({
    type: PagesActionTypes.UPDATE_PAGE_DATA_FAILURE,
    payload,
});

export const updatePageDataSuccess: ActionCreator<UpdatePageDataSuccessActionType> = payload => ({
    type: PagesActionTypes.UPDATE_PAGE_DATA_SUCCESS,
    payload,
});

/* -- Update Page Actions -- */

export const updatePageRequest: ActionCreator<UpdatePageRequestActionType> = payload => ({
    type: PagesActionTypes.UPDATE_PAGE_REQUEST,
    payload,
});

export const updatePageFailure: ActionCreator<UpdatePageFailureActionType> = payload => ({
    type: PagesActionTypes.UPDATE_PAGE_FAILURE,
    payload,
});

export const updatePageSuccess: ActionCreator<UpdatePageSuccessActionType> = payload => ({
    type: PagesActionTypes.UPDATE_PAGE_SUCCESS,
    payload,
});
